import { Tab, Tabs } from '@mui/material';
import { AppConfig } from 'AppConfig';
import { fetchData } from 'features/user/userActions';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, Outlet, useLocation } from 'react-router-dom';
import routePaths from 'routes/routePaths';
import { tabNoUnderlineSx, tabsNoUnderlineSx } from 'common/tabSx';
import { store } from 'store/store';

const TenantAdminNavigator = () => {
  const TENANT_USER_ACCESS_URL = routePaths.tenantAdmin;
  const location = useLocation();
  const { defaultUserState, currentTenantCd } = useSelector(
    (state) => state.user
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (defaultUserState) {
        store.dispatch(fetchData(currentTenantCd, AppConfig.APP_CODE_FO, { explicitTenant: false }));
      }
    }, 100);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <Tabs
        value={location.pathname}
        indicatorColor="primary"
        textColor="primary"
        sx={tabsNoUnderlineSx}>
        <Tab
          label="Tenant User Access"
          value={TENANT_USER_ACCESS_URL}
          component={Link}
          to={TENANT_USER_ACCESS_URL}
          sx={tabNoUnderlineSx}
        />
      </Tabs>
      <Outlet />
    </>
  );
};

export default TenantAdminNavigator;
